import React from 'react';
import '../../assets/styles/SuperAdmin/SATheme.css';

const SAPermPill = ({ level, onChange, locked }) => {
    const levels = ["none", "read", "write", "full"];
    const cfg = {
        none: { bg: "var(--sa-bg)", c: "var(--sa-dim)", b: "var(--sa-border)" },
        read: { bg: "rgba(77, 168, 255, 0.1)", c: "var(--sa-blue)", b: "rgba(77, 168, 255, 0.18)" },
        write: { bg: "rgba(253, 171, 61, 0.1)", c: "var(--sa-orange)", b: "rgba(253, 171, 61, 0.18)" },
        full: { bg: "rgba(0, 214, 143, 0.1)", c: "var(--sa-green)", b: "rgba(0, 214, 143, 0.18)" }
    };

    const s = cfg[level] || cfg.none;

    return (
        <div
            onClick={() => { if (!locked) onChange(levels[(levels.indexOf(level) + 1) % 4]); }}
            style={{
                display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 4,
                padding: "4px 10px", borderRadius: 6, fontSize: 10, fontWeight: 800,
                background: s.bg, color: s.c, border: `1px solid ${s.b}`,
                cursor: locked ? "not-allowed" : "pointer", textTransform: "uppercase",
                letterSpacing: "0.06em", transition: "all 0.15s", userSelect: "none",
                opacity: locked ? 0.4 : 1, minWidth: 48,
            }}
        >
            {locked && "🔒 "}{level}
        </div>
    );
};

export default SAPermPill;
